// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Column from '../../../components/Column';
import Row from '../../../components/Row';
import Button from '../../../components/Button';
import { Link } from 'react-router-dom';
const S = {
  Container: styled(Column)`
    display: flex;
    height: 100%;
  `,
  Button: styled(Button)`
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    width: 112px;
    box-shadow: revert;
  `,
  BottomWrapper: styled(Row)`
    margin-top: 41px;
    margin-bottom: 0px;
    justify-content: space-between;
  `,
  TopWrapper: styled(Column)`
  `,
  PasswordWrapper: styled.div`
    position: relative;
  `,
  GotoForgetPassword: styled(Link)`
    font-size: 16px;
    line-height: 23px;
    color: #EF8200;
    position: absolute;
    top: 66px;
    right: 0px;
  `,
  GoToNewAccountPage: styled(Link)`
    font-size: 16px;
    line-height: 23px;
    color: #EF8200;
    margin-left: 10px;
  `,
  GoToNewAccountPageWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #848484;
    display: flex;
    align-items: center;
  `
}

export { S as default }
